import type { LinkTypeType } from "@/types/graphql/partner.generated";

export const LINK_TYPE_LABEL_KEYS: Record<LinkTypeType, string> = {
  INTERNAL: "links.type.internal",
  EXTERNAL: "links.type.external",
} as const;
